<template>
    <div class="bkp-mobile-container">
        <detail-frame
            biz-type="BKP"
            :base-info="baseInfo"
            :tab-list="tabList"
            @onToBuy="onToBuy"
        >
            <template v-slot:product-detail>
                <div class="detail-item specity-color">
                    <div class="introduce-title"></div>
                    <div class="detail-item-sub">
                        企业支付不到一个人的成本，就可以享受到全国专业的服务；服务标准、定价公开透明、信息安全保密、服务进度透明、实时在线可查；覆盖全国主要区域，满足不同类型的企业需求，帮您轻松完成企业财务税务管理。
                    </div>
                    <div class="introduce-wrap">
                        <div
                            v-for="(item, index) in intro"
                            :key="index"
                            class="introduce-item"
                        >
                            <img :src="item.icon" alt="">
                            <p>{{ item.text }}</p>
                        </div>
                    </div>
                </div>
                <div class="detail-item">
                    <div class="content-title"></div>
                    <div class="content-wrap">
                        <div class="content-img"></div>
                        <div class="content-list">
                            <div v-for="(item, index) in serviceContent" :key="index">
                                <i class="content-gou-icon"></i>
                                <span>{{ item }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-item specity-color">
                    <div class="advantage-title"></div>
                    <div class="advantage-wrap">
                        <div
                            v-for="(item, index) in advantage"
                            :key="index"
                            class="advantage-item"
                        >
                            <div class="advantage-item-header">
                                <img class="advantage-icon1" :src="item.icon"/>
                                <p>{{ item.title }}</p>
                            </div>
                            <div class="advantage-item-content">{{ item.des }}</div>
                        </div>
                    </div>
                </div>
                <div class="detail-item">
                    <div class="process-title"></div>
                    <div class="process-wrap">
                        <img src="../../assets/mobile/bkp/process-img.png" alt="">
                    </div>
                </div>
                <div class="detail-item specity-color">
                    <div class="materials-title"></div>
                    <div class="materials-wrap">
                        <div
                            v-for="(item, index) in materials"
                            :key="index"
                            :class="item.className"
                        >
                            <div class="materials-item-header">
                                {{ item.title }}
                            </div>
                            <div class="materials-item-content">
                                <p v-for="(des, desIndex) in item.des" :key="desIndex">
                                    <span>{{ des }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-item">
                    <div class="problem-title"></div>
                    <div class="problem-wrap">
                        <div
                            v-for="(item, index) in problem"
                            :key="index"
                            class="problem-item"
                        >
                            <div class="item-left"></div>
                            <div class="item-right">
                                <div class="problem-header">{{ item.title }}</div>
                                <div class="problem-content">{{ item.des }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:drawer>
                <bpk-optional ref="optional"></bpk-optional>
            </template>
        </detail-frame>
    </div>
</template>

<script>
import {stringify} from 'qs';
import {resetRem, checkTwo} from '../../util/helper';
import DetailFrame from '../../components/mobile/detailFrame.vue';
import BpkOptional from '../../components/mobile/bpkOptional.vue';
import {productIntroTabSource} from '../data/global';
import {baseInfoModile, serviceContent, advantage, materials, problem,
    intro
} from '../data/bkp';

export default {
    props: {
        activetab: {
            type: String,
            default: 'intro'
        }
    },

    components: {
        DetailFrame,
        BpkOptional
    },

    data() {
        return {
            isShowDialog: false,
            tabList: productIntroTabSource.BKP,
            baseInfo: baseInfoModile,
            serviceContent,
            advantage,
            materials,
            problem,
            intro
        };
    },

    created() {
        resetRem();
        checkTwo();
    },

    methods: {
        onScrollDetail(index) {
            window.scrollTo({
                top: this.scrollHeightList[index],
                behavior: 'smooth'
            });
        },

        onHideDialog() {
            this.isShowDialog = false;
        },

        onShowDialog() {
            this.isShowDialog = true;
        },
        onToBuy() {
            const formData = this.$refs.optional.getFormData();
            const url = '#/order/bkp/confirm?';
            window.location.href = url + stringify(formData);
        }
    }
};
</script>

<style lang="less">
.bkp-mobile-container {
    background-color: #f5f5f5;
    padding-bottom: 12.8rem;

    .detail-item {
        padding: 0 3.4rem;
        background-color: #fff;
        overflow: hidden;

        .introduce-title,
        .content-title,
        .advantage-title,
        .process-title,
        .materials-title,
        .problem-title {
            margin: 2.8rem auto 2.4rem auto;
            background-size: auto 100%;
            background-repeat: no-repeat;
            background-position: center;
            height: 9rem;
            max-height: 50px;
        }

        .introduce-title {
            background-image: url(../../assets/mobile/bkp/introduction-title.png);
        }

        .content-title {
            background-image: url(../../assets/mobile/bkp/content-title.png);
        }

        .advantage-title {
            background-image: url(../../assets/mobile/bkp/advantage-title.png);
        }

        .process-title {
            background-image: url(../../assets/mobile/bkp/process-title.png);
        }

        .materials-title {
            background-image: url(../../assets/mobile/bkp/materials-title.png);
        }

        .problem-title {
            background-image: url(../../assets/mobile/bkp/problem-title.png);
        }

        .detail-item-sub {
            font-family: PingFangSC-Regular;
            font-size: 2.6rem;
            color: #70758B;
            letter-spacing: 0;
            font-weight: 400;
        }
    }

    .introduce-wrap {
        display: flex;
        justify-content: space-between;
        margin: 2.8rem 0 4rem 0;
        .introduce-item {
            width: 12rem;
            img {
                display: block;
                width: 12rem;
                max-width: 65px;
                max-height: 65px;
                height: 12rem;
            }
            p {
                font-family: PingFangSC-Regular;
                font-size: 2.8rem;
                color: #454864;
                letter-spacing: 0;
                text-align: center;
                font-weight: 400;
                margin-top: 2rem;
            }
        }
    }

    .content-wrap {
        .content-img {
            height: 30rem;
            max-height: 165px;
            background-image: url(../../assets/mobile/bkp/content-img.png);
            background-size: 100% 100%;
        }
        .content-list {
            display: flex;
            flex-wrap: wrap;
            > div {
                margin: 0 3rem 2.8rem 0;
                display: flex;
                align-items: flex-start;
            }
            span {
                font-family: PingFangSC-Regular;
                font-size: 2.8rem;
                color: #1B1E3F;
                letter-spacing: 0;
                font-weight: 400;
                display: inline-block;
                max-width: 93%;
            }
        }
        .content-gou-icon {
            width: 2.8rem;
            min-width: 2.8rem;
            height: 100%;
            min-height: 2.8rem;
            display: inline-block;
            background-image: url(../../assets/mobile/bkp/content-gou-icon.png);
            background-size: 100% auto;
            background-repeat: no-repeat;
            margin-right: 1.5rem;
            margin-top: 0.6rem;
        }
    }

    .advantage-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-bottom: 1rem;
        .advantage-item {
            width: 48%;
            max-width: 32.6rem;
            background: #fff;
            box-shadow: 0.2rem 0.2rem 1.4rem 0 rgba(42, 98, 254, 0.14);
            border-radius: 0.4rem;
            padding: 2rem 2rem 1.8rem 2rem;
            box-sizing: border-box;
            margin-bottom: 3rem;
        }
        .advantage-item-header {
            display: flex;
            align-items: center;
            p {
                font-family: PingFangSC-Medium;
                font-size: 2.8rem;
                color: #2A62FE;
                letter-spacing: 0;
                font-weight: 500;
            }
        }
        .advantage-icon1 {
            width: 4.8rem;
            height: 4.8rem;
            background-image: url(../../assets/mobile/bkp/advantage-icon1.png);
            background-size: 100% 100%;
            margin-right: 2rem;
        }
        .advantage-item-content {
            opacity: 0.5;
            font-family: PingFangSC-Regular;
            font-size: 2.4rem;
            color: #1B1E3F;
            letter-spacing: 0;
            font-weight: 400;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            margin-top: 1.8rem;
        }
    }

    .process-wrap {
        width: 56.2rem;
        max-width: 300px;
        height: auto;
        max-height: 74rem;
        margin: 0 auto 4rem auto;
        img {
            width: 100%;
            height: 100%;
        }
    }

    .materials-wrap {
        padding-bottom: 1rem;;
        >div {
            background: #fff;
            border-radius: 0.4rem;
            margin-bottom: 3rem;
        }
        .materials-item-header {
            font-family: PingFangSC-Medium;
            font-size: 2.8rem;
            color: #FFFFFF;
            letter-spacing: 0;
            font-weight: 500;
            background-size: 100% 100%;
            padding: 2rem 2.4rem;
        }
        .materials-item-content {
            padding: 3rem 5rem;
            p {
                font-family: PingFangSC-Regular;
                font-size: 2.4rem;
                color: rgba(27, 30, 63, 0.5);
                letter-spacing: 0;
                font-weight: 400;
                position: relative;
                &::before {
                    content: '';
                    position: absolute;
                    left: -3rem;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 1rem;
                    height: 1rem;
                    background-image: linear-gradient(135deg, #86aaf3 0%, #2469f3 100%);
                    border-radius: 50%;
                }
            }
            p:nth-child(2n-1) {
                margin-bottom: 2.4rem;
            }
        }
        .materials-item1 {
            .materials-item-header {
                background-image: url(../../assets/mobile/bkp/material-img1.png);
            }
        }
        .materials-item2 {
            .materials-item-header {
                background-image: url(../../assets/mobile/bkp/material-img2.png);
            }
        }
        .materials-item3 {
            .materials-item-header {
                background-image: url(../../assets/mobile/bkp/material-img3.png);
            }
        }
    }

    .problem-wrap {
        .problem-item {
            margin-bottom: 2.8rem;
            display: flex;
        }
        .item-left {
            width: 3.2rem;
            min-width: 3.2rem;
            height: 3.2rem;
            background-image: url(../../assets/mobile/bkp/problem-icon.png);
            background-size: 100% 100%;
            margin: 0.5rem 2rem 0 0;
        }
        .item-right {
            width: 62.4rem;
        }
        .problem-header {
            font-family: PingFangSC-Medium;
            font-size: 3rem;
            color: #1B1E3F;
            letter-spacing: 0;
            font-weight: 500;
            margin-bottom: 1.8rem;
        }
        .problem-content {
            padding: 0;
            opacity: 0.5;
            font-family: PingFangSC-Regular;
            font-size: 2.6rem;
            color: #1B1E3F;
            letter-spacing: 0;
            font-weight: 400;
        }
    }

    .specity-color {
        background-color: #f5f9ff;
    }

    .el-drawer {
        border-radius: 2rem 2rem 0 0;
        padding: 3rem;
    }

}
</style>